/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserModel } from '../../models/user-model';

export interface UserIdGet$Json$Params {
  id: string;
}

export function userIdGet$Json(http: HttpClient, rootUrl: string, params: UserIdGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<UserModel>> {
  const rb = new RequestBuilder(rootUrl, userIdGet$Json.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<UserModel>;
    })
  );
}

userIdGet$Json.PATH = '/User/{id}';
